import { render, staticRenderFns } from "./Sign.vue?vue&type=template&id=21a4c253&"
import script from "./Sign.vue?vue&type=script&lang=ts&"
export * from "./Sign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports